import React, { useState } from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import { withApollo } from 'react-apollo';
import SearchIcon from '@material-ui/icons/Search';
import IconButton from '@material-ui/core/IconButton';
import { navigate } from '@reach/router';
import debounce from 'debounce-promise';
import Async from 'react-select/async';

import { SEARCH_PRODUCTS } from '../../queries';
import classes from './search.module.scss';
import styles from './select.styles';

const Search = props => {
  const [isOpened, toggleOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const navigateToProduct = ({ value }, { action }) => {
    navigate(`/product/${value}`);
    toggleOpen(false);
    if (action === 'select-option') setSelectedValue(null);
  };

  const getAsyncOptions = (searchStr: string) => {
    if (searchStr.length < 3) return;
    return props.client
      .query({ query: SEARCH_PRODUCTS, variables: { searchStr } })
      .then(({ data: { productsSearch } }) => {
        return productsSearch.map(({ name: label, id: value }) => ({
          label,
          value
        }));
      });
  };
  const debouncedGetOptions = debounce(input => getAsyncOptions(input), 1000, {
    leading: true
  });
  const loadOptions = input => debouncedGetOptions(input);

  return (
    <div
      className={`${classes.searchBox} ${
        isOpened ? classes.searchBoxVisible : ''
      }`}
      data-e2e-id="search-wrapper"
    >
      <Async
        styles={styles}
        className={`${classes.searchInputWrapper} ${
          isOpened ? classes.searchInputWrapperVisible : ''
        }`}
        loadingMessage={({ inputValue }) => `Шукаю ${inputValue}...`}
        noOptionsMessage={() => 'Нічого не знайдено.'}
        placeholder=""
        classNamePrefix="selectSearch"
        openMenuOnClick={false}
        loadOptions={loadOptions}
        onChange={navigateToProduct}
        value={selectedValue}
        data-e2e-id="search-input"
      />
      <IconButton
        data-e2e-id="search-toggle-btn"
        onClick={() => toggleOpen(!isOpened)}
      >
        <SearchIcon className={classes.icon} />
      </IconButton>
    </div>
  );
};

export default withTheme()(withStyles(classes as any)(withApollo(Search)));
